export default {
  nameCol: {
    width: 180,
  },
  addressCol: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  actionCol: {
    width: 180,
    textAlign: 'right',
  },
  primaryCol: {
    width: 80,
    // paddingLeft: 0,
    // paddingRight: 0,
  },
  noData: {
    fontSize: 200,
    color: 'lightgrey',
  },
  icon: {
    paddingLeft: 3,
    paddingRight: 3,
  },
};



// WEBPACK FOOTER //
// ./src/components/ContactsTable/styles.js